module.exports = __webpack_public_path__ + "img/adaptabilidad.b92edc3c.png";